import React from "react";
import RevealRoot from "@/components/landing/RevealRoot";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Ticker from "@/components/landing/Ticker";
import ProofBar from "@/components/landing/ProofBar";
import Features from "@/components/landing/Features";
import ToolBreakdown from "@/components/landing/ToolBreakdown";
import HowItWorks from "@/components/landing/HowItWorks";
import AnimatedDemo from "@/components/landing/AnimatedDemo";
import WhoFor from "@/components/landing/WhoFor";
import Comparison from "@/components/landing/Comparison";
import ValueStack from "@/components/landing/ValueStack";
import Plans from "@/components/landing/Plans";
import Community from "@/components/landing/Community";
import Reviews from "@/components/landing/Reviews";
import MidCTA from "@/components/landing/MidCTA";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import ExitIntent from "@/components/landing/ExitIntent";
import SEO from "@/components/SEO";
import { usePrice } from "@/lib/price";

export default function Landing() {
  const { price } = usePrice();
  return (
    <div
      data-testid="landing-page"
      className="bg-[#FDFBF7] text-[#0a0a0a] min-h-screen"
    >
      <RevealRoot>
        <SEO
          title="JobHacki — Hack your career. Live ATS jobs, ATS-proof resumes, AI role-play."
          description={`The unfair toolkit for ambitious operators. Live ATS jobs from 18,000+ company boards, ATS-bulletproof resumes, a 0-100 resume match engine, AI role-play interviews, 100+ grounded playbooks. One-time ${price} — lifetime access.`}
          canonical="https://jobhacki.com/"
        />
        <Navbar />
        <Hero />
        <Ticker />
        <ProofBar />
        <Features />
        <ToolBreakdown />
        <HowItWorks />
        <AnimatedDemo />
        <WhoFor />
        <Comparison />
        <ValueStack />
        <Plans />
        <MidCTA />
        <Community />
        <Reviews />
        <FAQ />
        <FinalCTA />
        <Footer />
      </RevealRoot>
      <ExitIntent />
    </div>
  );
}
